import Api from '@/modules/core/api/api.ts';
import { AuthEndPoint } from '@/modules/common/enums/end-point.ts';
import type { LoginFormData } from '@/modules/core/components/LoginPage.vue';
import { TokensAdapter } from '@/modules/common/adapters/tokens.adapter.ts';
import { AuthAdapter } from '@/modules/common/adapters/auth.adapter.ts';

export default class AuthApi {
  static async login(request: LoginFormData) {
    const [user_login, org_ident] = request.login.split('@');

    const response = await Api.post(
      AuthEndPoint.Login,
      {
        user_login,
        org_ident,
        user_password: request.password,
      },
      undefined,
      false
    );

    return AuthAdapter.map(response);
  }

  static async refresh(refreshToken: string) {
    const response = await Api.postRaw(AuthEndPoint.Refresh, { refresh_token: refreshToken });
    return TokensAdapter.map(response);
  }
}
